// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'

// Internal Dependencies:
import Link from 'components/Link/Link'
import { smoothScrollTo } from 'utilities/scroll'
import ArrowUp from 'components/svg/arrows/arrow-up.svg'
import LongArrowL from 'components/svg/arrows/long-arrow-left.svg'
import LongArrowR from 'components/svg/arrows/long-arrow-right.svg'

class PageNavFrame extends React.Component {
	handleScrollTop = () => {
		smoothScrollTo( 0, 1000 )
	}

	handleClick = ( e ) => {
		e.currentTarget.blur()
	}

	render() {
		const { page, match, mobile, footerNav } = this.props
		const className = mobile ? 'page-nav-mobile' : footerNav ? 'page-nav-footer' : 'page-nav-frame'

		if ( ! page ) {
			return null
		}

		// Always show left and right, default to home.
		let prevUrl = '/',
			nextUrl = '/'

		if ( page.prev_post_slug ) {
			prevUrl = match.path.replace( ':slug', page.prev_post_slug )
		}

		if ( page.next_post_slug ) {
			nextUrl = match.path.replace( ':slug', page.next_post_slug )
		}

		// Footer version:
		if ( footerNav ) {
			return (
				<div className={ className }>
					{ prevUrl &&
						<Link className="-left" to={ prevUrl } transitionType="leftToRight" onClick={ this.handleClick }>
							<span className="-inner">
								<LongArrowL />

								<span>Prev<span>ious Project</span></span>
							</span>
						</Link>
					}

					{ nextUrl &&
						<Link className="-right" to={ nextUrl } transitionType="rightToLeft" onClick={ this.handleClick }>
							<span className="-inner">
								<LongArrowR />

								<span>Next<span> Project</span></span>
							</span>
						</Link>
					}
				</div>
			)
		}

		// Actual frame version:
		return (
			<div className={ className }>
				<div className="-left">
					{ prevUrl &&
						<Link to={ prevUrl } className="-prev" transitionType="leftToRight" onClick={ this.handleClick }>
							<LongArrowL />

							<span>Previous</span>
						</Link>
					}
				</div>

				<div className="-center"></div>

				<div className="-right">
					<div className="-up circle-button" onClick={ this.handleScrollTop }>
						<ArrowUp />
					</div>

					{ nextUrl &&
						<Link to={ nextUrl } className="-next" transitionType="rightToLeft" onClick={ this.handleClick }>
							<LongArrowR />

							<span>Next</span>
						</Link>
					}
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		page: state.page.selected
	}
}

export default connect( mapStateToProps )( PageNavFrame )



// WEBPACK FOOTER //
// ./components/PageNavFrame/PageNavFrame.jsx